import React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import ProfileTotalDetails from "../../components/sections/front/ProfileTotalDetails.jsx";
import { profileDetails } from "../../services/ProfileService.js";
import { useSelector } from "react-redux";

const ProfileDetails = () => {
  // const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("userId");
  const { session } = useSelector((state) => state.authProvider);

  const isOwnProfile = !userId;
  const { data, isLoading } = useQuery({
    queryKey: ["profile-details", userId],
    queryFn: async () => {
      // 👉 OWN PROFILE
      if (isOwnProfile) {
        return await profileDetails();
      }

      // 👉 OTHER USER
      return await profileDetails({ userId });
    },
  });

  if (isLoading) return <div>Loading...</div>;
  if (!data?.data) return <div>No profile found</div>;

  return <ProfileTotalDetails user={data.data} />;
};

export default ProfileDetails;
